import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SystemApiService } from '@cv-invision/core';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';
import { ProductModel } from '../model/products.model';
import { TrackingModel } from '../model/tracking.model';

@Injectable()
export class ProductsService {
    constructor(private systemApiService: SystemApiService, private httpClient: HttpClient) {}

    /**
     * Obtains a ruleset products collection by tracking id.
     * @param {string[]} trackingIds - The tracking id passed to the endpoint.
     *
     * @returns {Observable<ProductModel[]>} - An observable containing a collection of products.
     */
    getProductsByMultipleTrackings(
        productTitleFilter?: string,
    ): Observable<ProductModel[]> {
        const trackings: TrackingModel[] = [{
            name: 'Appscope',
            id: 'appscope'
        },
        {
            name: 'CMP Acuity',
            id: 'cmpacuity'
        },
    ];
        const limit = 50;
        const requests = trackings.map((tracking) => {
            let params = new HttpParams().set('Limit', limit);
            if (productTitleFilter && productTitleFilter.trim().length > 0) {
              params = params.set('Title', productTitleFilter.trim());
            }
            // Append tracking at the end of the URL
            return this.httpClient
              .get<any>(`${this.systemApiService.api['orders']}/products/${tracking.id}`, { params })
              .pipe(
                map((response) => {
                  return (
                    response.map((product) => {
                      const productObject: ProductModel = new ProductModel();
                      productObject.id = `${tracking.id}-${product.id}`;
                      productObject.name = `${tracking.name} - ${product.title}`;
                      return productObject;
                    }) ?? []
                  );
                }),
                catchError((err) => {
                  console.error(`Failed for tracking ${tracking}:`, err);
                  return of([]);
                })
              );
          });

        return forkJoin(requests).pipe(map((results: ProductModel[][]) => results.flat()));
    }

    /**
     * Gets a trackings collection from the api.
     *
     * @returns {Observable<TrackingModel[]>} - An observable of a trackings collection.
     */
    getTrackings(): Observable<TrackingModel[]> {
        return this.httpClient
            .get<any[]>(`${this.systemApiService.api['orders']}/utils/tracking-systems`)
            .pipe(
                map((response) =>
                    // throw away any whose id === 'Acuity'
                    response
                        .filter((raw) => raw.id !== 'Acuity')
                        // then map the remainder into your model
                        .map((raw) => {
                            const t = new TrackingModel();
                            t.id = raw.id;
                            t.name = raw.title;
                            return t;
                        }),
                ),
            );
    }
}
